/**
 * Проверяет, заполнен ли профиль клиента обязательными полями:
 * - телефон
 * - дата рождения
 * - дата внесения средств (информации об активах)
 * @param {Object} client - объект клиента из state.interfaceComponents.client
 * @returns {boolean}
 */
export const isProfileFilled = (client) => {
  if (!client) return false;

  const hasPhone =
    typeof client.phone === 'string' ? client.phone.trim().length > 0 : !!client.phone;

  const birthAt = client.birth_at;
  const startEnterAt = client.start_enter_at;

  const hasBirthDate = !!(
    birthAt && (typeof birthAt === 'string' ? birthAt.trim().length > 0 : true)
  );

  const hasStartEnterAt = !!(
    startEnterAt && (typeof startEnterAt === 'string' ? startEnterAt.trim().length > 0 : true)
  );

  return hasPhone && hasBirthDate && hasStartEnterAt;
};
